module.exports = __webpack_public_path__ + "static/img/3491_phase_function_Paper_Points.aa7a7bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3491_phase_function_Paper_Points.png
// module id = jqAS
// module chunks = 0